import React from 'react';
import { Users, Target, Award, Globe } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function About() {
  return <div className="min-h-screen bg-slate-950" data-id="element-94">
      {/* Hero */}
      <section className="py-20 border-b border-slate-800" data-id="element-95">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-96">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-97">
            Our Mission
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-98">
            We are building the world's most advanced network intelligence
            platform to help enterprises secure and optimize their digital
            infrastructure.
          </p>
        </div>
      </section>

      {/* Values */}
      <section className="py-24" data-id="element-99">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-101">
            {[{
            icon: <Target className="h-8 w-8 text-cyan-400" data-id="element-102" />,
            title: 'Precision',
            desc: 'We believe in data accuracy down to the nanosecond. No estimation, just facts.'
          }, {
            icon: <Users className="h-8 w-8 text-cyan-400" data-id="element-103" />,
            title: 'Customer First',
            desc: 'Our roadmap is driven by the real-world needs of network engineers and security pros.'
          }, {
            icon: <Award className="h-8 w-8 text-cyan-400" data-id="element-104" />,
            title: 'Excellence',
            desc: "We push the boundaries of what's possible in distributed systems engineering."
          }, {
            icon: <Globe className="h-8 w-8 text-cyan-400" data-id="element-105" />,
            title: 'Global Scale',
            desc: "Built from day one to handle the traffic of the world's largest networks."
          }].map((value, idx) => <Card key={idx} className="bg-slate-900/50 border-slate-800 hover:border-cyan-500/50 transition-all duration-300" data-id="element-106">
                <div className="mb-4" data-id="element-107">{value.icon}</div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-108">
                  {value.title}
                </h3>
                <p className="text-slate-400" data-id="element-109">{value.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Story */}
      <section className="py-24 bg-slate-900/30 border-y border-slate-800" data-id="element-110">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-111">
          <h2 className="text-3xl font-bold text-white mb-8" data-id="element-112">Our Story</h2>
          <div className="space-y-6 text-lg text-slate-400 leading-relaxed" data-id="element-113">
            <p data-id="element-114">
              Founded in 2023 by a team of veteran network engineers from
              leading technology companies, njgod was born out of frustration
              with existing legacy tools. We saw a gap in the market for a
              platform that could handle the scale and complexity of modern
              cloud-native infrastructure without sacrificing usability or
              performance.
            </p>
            <p data-id="element-115">
              Today, njgod processes petabytes of data daily for some of the
              world's most demanding enterprises. Our distributed architecture
              allows us to monitor networks from over 100 global points of
              presence, giving our customers a true "god-mode" view of their
              infrastructure with unprecedented visibility and control.
            </p>
            <p data-id="element-116">
              We operate globally with presence in Singapore, Tokyo, and Tel
              Aviv, serving enterprise customers worldwide. Our commitment to
              innovation and customer success drives everything we do, from
              product development to support delivery.
            </p>
          </div>
        </div>
      </section>
    </div>;
}